"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsDataDefault = void 0;
const WAKEONLAN_DEFAULT_PORT = 9;
exports.settingsDataDefault = {
    autoDetectNetworks: true,
    ipNetworks: [],
    wolPort: WAKEONLAN_DEFAULT_PORT
};
//# sourceMappingURL=SettingsData.js.map